/**
 * Created by Mikhail Menshenin on 07.07.2025
 */

const RiddlesLevelMasteryTimer = cc.Node.extend({
    ctor: function (countDown, styles) {
        this._super();
        this.setAnchorPoint(0.5, 0.5);

        this.countDown = countDown;
        this.styles = styles;
        this.createBg();
        this.createCountDown();
        this.createIcon();
        cleverapps.UI.wrap(this);
    },

    createBg: function () {
        const bg = cleverapps.UI.createScale9Sprite(this.styles.background.frame, cleverapps.UI.Scale9Rect.TwoPixelXY);
        bg.setAnchorPoint(0, 0);
        bg.setContentSize(this.styles.background.width, this.styles.background.height || bg.height);
        this.setContentSize2(bg.getContentSize());
        this.addChild(bg);
    },

    createCountDown: function () {
        const countDownView = new cleverapps.CountDownView(this.countDown, {
            font: this.styles.font
        });
        if (this.styles.countDown.width) {
            countDownView.fitTo(this.styles.countDown.width, this.styles.countDown.height || countDownView.height);
        }
        countDownView.setAlignment(this.styles.countDown);
        this.addChild(countDownView);
    },

    createIcon: function () {
        const icon = new cc.Sprite(this.styles.icon.frame);
        icon.setAlignment(this.styles.icon);
        this.addChild(icon);
    }
});